import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ResultImageResponse } from '../../models/response.module';

@Component({
  selector: 'app-document-viewer-modal',
  standalone: false,
  templateUrl: './document-viewer-modal.html',
  styleUrl: './document-viewer-modal.css'
})
export class DocumentViewerModal implements OnInit {
  @Input() images: ResultImageResponse[] = [];
  @Input() title: string = 'Images';

  currentIndex: number = 0;
  private safeUrlCache: Map<string, SafeResourceUrl> = new Map();

  constructor(
    private modal: NgbActiveModal,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {}

  get currentImage(): ResultImageResponse | null {
    return this.images[this.currentIndex] || null;
  }

  get safeImageUrl(): SafeResourceUrl | null {
    if (!this.currentImage?.image_url) return null;
    const url = this.currentImage.image_url;
    if (!this.safeUrlCache.has(url)) {
      this.safeUrlCache.set(url, this.sanitizer.bypassSecurityTrustResourceUrl(url));
    }
    return this.safeUrlCache.get(url)!;
  }

  previous() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    }
  }

  next() {
    if (this.currentIndex < this.images.length - 1) {
      this.currentIndex++;
    }
  }

  close() {
    this.modal.dismiss();
  }
}
